import { FeeDisclaimer } from '../types';

export const mockFeeDisclaimers: FeeDisclaimer[] = [
  {
    id: 'fd-1',
    name: 'Field Trip Liability Waiver',
    title: 'Field Trip Participation Agreement',
    content: `## Acknowledgment of Risk

By participating in this field trip, I acknowledge and understand the following:

### Participant Responsibilities
- **Risk Awareness**: I understand that field trips involve inherent risks including, but not limited to, transportation risks, physical activities, and exposure to unfamiliar environments
- **Emergency Contact**: I confirm that my emergency contact information is **current and accurate**
- **Medical Information**: All necessary medical information has been provided to the school

### Release of Liability
I agree to release and hold harmless:
1. The school and its administration
2. All staff members and chaperones
3. Transportation providers
4. Venue operators and their staff

### Important Notes
> **Medical Insurance**: Participants should have adequate medical insurance coverage
> **Behavior Standards**: All students must adhere to school behavior policies during the trip
> **Supervision**: Students must stay with designated chaperone groups at all times`,
    requiresSignature: true,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'fd-2',
    name: 'Athletic Program Waiver',
    title: 'Athletic Program Participation Waiver',
    content: `## Athletic Program Participation Agreement

### Understanding the Risks
Participation in athletic programs involves **inherent physical risks** that may result in injury. By registering for this program, participants acknowledge these risks.

### Types of Activities Covered
This waiver applies to all athletic activities including:
- Regular practice sessions
- Competitive games and matches
- Training camps and clinics
- Travel to and from athletic events
- Conditioning and strength training

### Requirements for Participation
1. **Medical Clearance**: Participants must have current physical examination on file
2. **Health Insurance**: All participants are required to have adequate health insurance coverage
3. **Equipment**: Proper athletic equipment must be worn at all times during activities
4. **Sportsmanship**: Participants agree to uphold the school's athletic code of conduct

### Release Agreement
I agree that the school and its staff shall **not be held liable** for:
- Injuries sustained during practices, games, or related activities
- Medical expenses resulting from participation
- Loss or damage to personal property

> ⚠️ **Important**: This waiver does not cover injuries resulting from gross negligence or intentional misconduct by school staff.`,
    requiresSignature: true,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'fd-3',
    name: 'Technology Device Agreement',
    title: 'Student Technology Use Agreement',
    content: `## Technology Device Responsibility Agreement

### Student Responsibilities
As a recipient of school-issued technology, students agree to:

**Device Care**
- Keep the device in a protective case at all times
- Charge the device nightly and bring it fully charged to school
- Keep food and beverages away from the device
- Never leave the device unattended

**Acceptable Use**
- Use devices **only for educational purposes** during school hours
- Comply with the school's Acceptable Use Policy
- Not install unauthorized software or applications
- Respect copyright and intellectual property laws

### Reporting Requirements
Students must **immediately report**:
1. Any damage to the device
2. Lost or stolen devices
3. Technical malfunctions
4. Cyberbullying or inappropriate content

### Financial Responsibility
| Incident Type | Responsibility |
|---------------|----------------|
| Normal wear and tear | Covered by school |
| Accidental damage (first occurrence) | Reduced fee |
| Repeated damage or negligence | Full replacement cost |
| Loss or theft | Full replacement cost |

> 📱 **Replacement Cost**: Current device replacement fees range from $300-$800 depending on the model.

### Consequences for Misuse
Violation of this agreement may result in:
- Loss of device privileges
- Disciplinary action
- Financial responsibility for damages`,
    requiresSignature: false,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
  {
    id: 'fd-4',
    name: 'Photo Release',
    title: 'Photo and Video Release Authorization',
    content: `## Media Release Authorization

### Permission Granted
By purchasing this item, you grant permission for the school to photograph and/or video record your student during:
- School activities and events
- Classroom instruction
- Athletic competitions
- Field trips and excursions
- School performances and presentations
- Campus activities

### Usage Authorization
These images and videos may be used in:
1. **School Publications**
   - Yearbooks
   - Newsletters
   - Annual reports
   - Brochures and flyers

2. **Digital Media**
   - School website
   - Social media accounts (Facebook, Instagram, Twitter)
   - Email communications
   - Virtual tours

3. **Promotional Materials**
   - Recruitment materials
   - Fundraising campaigns
   - Community outreach

### Privacy Protection
The school commits to:
- **No full names** will be used in conjunction with photos on public platforms without additional consent
- Student information will not be shared with third parties
- Images will only be used for educational and promotional purposes related to the school

### Your Rights
- You may revoke this authorization at any time by submitting a written request
- Revocation will not affect materials already in distribution
- You have the right to request removal from future publications

> 📸 **Note**: This release does not obligate the school to photograph your student, nor does it guarantee inclusion in any particular publication.`,
    requiresSignature: false,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01'),
  },
];
